import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
  // Desktop coach profile shows CTAs in the hero summary row (CoachBio); hide the fixed bar + spacer.
  ctaBannerRoot: {
    [theme.breakpoints.up('md')]: {
      display: 'none',
    },
  },
  banner: {
    position: 'fixed',
    bottom: 'unset',
    display: 'flex',
    alignItems: 'center',
    height: '60px',
    width: '100%',
    backgroundColor: '#EBEFF5',
    zIndex: theme.zIndex.appBar - 1,
    boxShadow: '0 1px 0 rgba(0, 35, 75, 0.08)',

    [theme.breakpoints.only('xs')]: {
      top: 'unset',
      bottom: '0',
      backgroundColor: '#FFFFFF',
      borderTop: `1px solid ${theme.palette.grey[300]}`,
      boxShadow: '0 -2px 12px rgba(0, 35, 75, 0.06)',
    },
  },
  bannerContainer: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
  },
  bookButton: ({ memberType }) => ({
    color: memberType ? '#FAFAFA' : '#043362',
    borderColor: memberType ? '#FAFAFA' : '#043362',
    backgroundColor: memberType ? '#043362' : 'unset',
    '&:hover': {
      backgroundColor: memberType ? '#043362' : 'unset',
      color: memberType ? '#FAFAFA' : '#043362',
      borderColor: memberType ? '#FAFAFA' : '#043362',
    },
  }),
  button: {
    height: '2.5rem',
    padding: '6px 24px',
    marginLeft: '1rem',
    '&:hover': {
      backgroundColor: 'unset',
    },

    [theme.breakpoints.only('xs')]: {
      height: '3rem',
      lineHeight: '1rem',
      textAlign: 'center',
      '&:first-of-type': {
        marginLeft: 0,
      },
    },
  },
  spacer: {
    width: '100%',
    // Side margins inherit page background; white column matches CoachBio 1200px canvas.
    backgroundColor: 'transparent',

    [theme.breakpoints.only('xs')]: {
      minHeight: 0,
    },
  },
  spacerContainer: {
    width: '100%',
  },
  spacerColumn: {
    height: '74px',
    width: '100%',
    backgroundColor: theme.palette.common.white,

    [theme.breakpoints.only('xs')]: {
      height: 0,
      minHeight: 0,
    },
  },
  buttonContainer: {
    display: 'flex',
    justifyContent: 'flex-end',

    [theme.breakpoints.only('xs')]: {
      width: '100%',
      justifyContent: 'center',
    },
  },
  externalLinkIcon: {
    marginLeft: '1rem',
    width: '1.5rem',
    height: '1.5rem',

    [theme.breakpoints.only('xs')]: {
      marginLeft: '0.5rem',
    },
  },
}))

export default useStyles
